module.exports = __webpack_public_path__ + "img/point_img5_sp.db111f58.png";